import React, { useState, useEffect } from 'react';
import upperFirst from 'lodash/upperFirst';
import NotifyIcon from '../../../images/notification-icon-outline.svg';
import CheckmarkCircle from '../../../images/checkmark-circle.svg';
import EmptyNotifications from '../../../images/empty-notifications.png';
import * as Styled from './NotificationsStyles';
import useObservable from '../../hooks/useObservable';
import OutsideAlerter from '../../hooks/OutsideAlerter';
import EntityIcon from '../EntityIcon/EntityIcon';
import NotificationsStore from '../../xstores/notifications';

const getMessage = (pl:string, account:string, type: string) => {
  let start = `Trova needs your help. Please reconnect your`;
  let message;
  if (type === 'token') {
    if (pl === 'slack') {
      message = (
        <span>
        {start} <span className="highlight">{account}</span> Team {upperFirst(pl)} account.
      </span>
      );
    } else {
      message = (
        <span>
        {start} {upperFirst(pl)} account “<span className="highlight">{account}</span>”
      </span>
      );
    }
  }
  if (type === 'indexing') {
    message = (
      <span>
        Your Microsoft Teams account setup in in progress! Trova may need some time to setup your account. We will notify you when setup is complete.
      </span>
    )
  }
  if (type === 'index-finish') {
    message = (
      <span>
        Microsoft Teams account setup is complete! You can start searching now!
      </span>
    )
  }

  return message
}

const Notifications = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [notifications, setNotifications] = useState<Array<any>>([]);
  const [hasUnread, setHasUnread] = useState(false);
  const notificationsObs = useObservable(NotificationsStore.current$, []);
  const toggleList = () => {
    setIsOpen(!isOpen);
  }

  const hideList = () => {
    setIsOpen(false);
  }

  const markAsRead = (e:any, notif?:any) => {
    NotificationsStore.markAsRead(notif);
  }

  useEffect(() => {
    const newNotifs = notificationsObs.map((n:any) => {
      return {
        ...n,
        message: getMessage(n.pl, n.account, n.type),
      }
    });
    setHasUnread(newNotifs.some((n:any) => !n.read));
    setNotifications(newNotifs)
  }, [notificationsObs]);

  return (
    <OutsideAlerter setFunction={hideList}>
      <Styled.Wrapper>
        <Styled.IconContainer onClick={toggleList}>
          <Styled.NotifyIcon src={NotifyIcon} />
          {hasUnread &&
            <Styled.RedDot className="top-position"/>
          }
        </Styled.IconContainer>
        <Styled.DropContainer className={isOpen ? 'visible' : ''}>
          <Styled.DropHeader>
            <span>Notifications</span>
            <Styled.MarkAsRead onClick={markAsRead}>
              Mark all as read <img src={CheckmarkCircle} alt="mark as read check" />
            </Styled.MarkAsRead>
          </Styled.DropHeader>
          <Styled.NotificationList>
            {notifications.length ?
              notifications.map((notif:any, i:number) => (
              <React.Fragment key={notif.nId}>
                <Styled.NotificationItem
                  onClick={(e) => markAsRead(e, notif)}
                  className={notif.read ? 'read' : ''}>
                  <EntityIcon entityName={notif.pl} showGLogo size="med" />
                  <Styled.NotificationMessage>
                    <div>{notif.message}</div>
                    {notif.type === 'token' ? (
                      <Styled.ActionButton to="/account">
                        Connect Again
                      </Styled.ActionButton>
                      ) : null}
                  </Styled.NotificationMessage>
                  <Styled.NotificationRead>
                    {!notif.read && <Styled.RedDot/>}
                  </Styled.NotificationRead>
                </Styled.NotificationItem>
                {
                  (i < notifications.length - 1) && <Styled.NotificationItemDivider />
                }
              </React.Fragment>
            )) :
              <Styled.EmptyContainer>
                <Styled.EmptyImage src={EmptyNotifications} alt="empty notifications list" />
                <div>You don't have any notifications.</div>
              </Styled.EmptyContainer>
            }
          </Styled.NotificationList>
        </Styled.DropContainer>
      </Styled.Wrapper>
    </OutsideAlerter>
  )
}

export default Notifications;